<!-- LISTA DE PRODUTOS -->
<div class="flex flex-col flex-1 min-h-0">
  <!-- Loading inicial -->
  <div class="flex flex-col justify-center flex-1 text-center text-gray-500 py-8" *ngIf="isLoading && products.length === 0">
    <p>Carregando produtos...</p>
  </div>

  <!-- LISTA DE RESULTADOS -->
  <div 
    #scrollContainer
    class="flex-1 min-h-0 w-full overflow-auto bg-gray-100 rounded-md"
    *ngIf="!isLoading || products.length > 0">
    <div class="p-2">
      <p class="text-sm font-semibold text-gray-700 mb-2 sticky top-0 bg-gray-100 pb-2">
        Produtos ({{ products.length }}{{ totalRecords > products.length ? ' / ' + totalRecords : '' }})
      </p>
      <div class="space-y-1">
        <div 
          *ngFor="let product of products; let i = index"
          [id]="'product-item-' + i"
          (click)="selectProductFromList(product)"
          [ngClass]="{
            'bg-orange-500 text-white': selectedProductIndex === i,
            'bg-white hover:bg-orange-50': selectedProductIndex !== i
          }"
          class="p-2 rounded cursor-pointer border border-gray-200 transition-colors">
          <div class="flex flex-col">
            <span class="font-semibold text-sm">{{ product.description }}</span>
            <div class="flex justify-between items-center mt-1">
              <span class="text-xs" [ngClass]="{'text-orange-100': selectedProductIndex === i, 'text-gray-600': selectedProductIndex !== i}">
                Código: {{ product.code }} | Estoque: {{ product.currentStock }}
              </span>
              <span class="font-bold text-sm" [ngClass]="{'text-white': selectedProductIndex === i, 'text-orange-600': selectedProductIndex !== i}">
                {{ product.priceSelling | currency:'BRL' }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- Indicador de carregamento de mais produtos -->
      <div class="flex justify-center items-center py-4" *ngIf="isLoadingMore">
        <p class="text-sm text-gray-500">Carregando mais produtos...</p>
      </div>

      <!-- Mensagem quando não há mais produtos -->
      <div class="flex justify-center items-center py-4" *ngIf="!hasMorePages && products.length > 0 && !isLoadingMore">
        <p class="text-sm text-gray-500">Todos os produtos foram carregados</p>
      </div>
    </div>
  </div>

  <!-- Mensagem quando não há produtos -->
  <div class="flex flex-col justify-center flex-1 text-center text-gray-500 py-8" *ngIf="products.length === 0 && !isLoading">
    <p>Nenhum produto encontrado</p>
  </div>
</div>

